module.exports = __webpack_public_path__ + "static/media/general.35221da0.md";